import React, { useState } from "react";
import MenuNewTableSize from "./MenuNewTableSize";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";

function AddTableButton({
  disabledClassName,
  disabledStyle,
}: {
  disabledClassName: string;
  disabledStyle: React.CSSProperties;
}) {
  const [isSizeMenuOpen, setIsSizeMenuOpen] = useState(false);
  const opacity = disabledClassName ? { opacity: 0.5 } : { opacity: 1 };

  return (
    <>
      <button
        id="wysiwyg-table-button"
        className={`wysiwyg-toolbar-btn ${disabledClassName}`}
        style={disabledStyle}
        onClick={() => {
          setIsSizeMenuOpen(true);
        }}
        data-tooltip-id="AddTable"
      >
        <span style={opacity} className="icon-table-icon"></span>
        <Tooltip id="AddTable" />
      </button>
      <MenuNewTableSize isSizeMenuOpen={isSizeMenuOpen} setIsSizeMenuOpen={setIsSizeMenuOpen} />
    </>
  );
}

export default AddTableButton;

{
  /* <button id="wysiwyg-table-button" className="wysiwyg-toolbar-btn" >
          <span className="icon-table-icon"></span>
        </button> */
}
